/* This code is exporting a variable named `developmentApi` with the value of
`process.env.REACT_APP_DEVELOPMENT`. */
export let developmentApi = process.env.REACT_APP_DEVELOPMENT;



